import angular from 'angular';

angular.module('cloudX').directive('cxSection', function() {
  return {
    restrict: 'E',
    template: require('./section.html'),
    scope: {
      section: '=data',
      relId: '@',
    },
    controller: 'SectionCtrl',
  };
});
